import actions from "./actions"
import getters from "./getters"
import mutations from "./mutations"

const state = {
  currentModule: "",
  currentPath: "",
  loader: false,
  drawerOpen: true,
  newVersionSnackbar: false,
  alert: {
    message: "",
    type: null,
    show: false,
    code: null,
    extras: null
  },
  axiosHideLoader: false,
  routeCount: 0,
  versionCheck: false
}

export default {
  namespaced: true,
  state,
  actions,
  getters,
  mutations
}
